<template>
  <v-row>
    <v-col cols="3" class="py-1">
      <v-avatar
        size="60px"
        class="rounded-un fakeLink"
        color="#7D4CA8"
        @click="goTo('/perfil')"
      >
        <v-img
          :src="user.avatar"
          width="100%"
          height="100%"
          v-if="user.avatar"
        ></v-img>
        <v-icon v-if="!user.avatar" x-large color="white">mdi-account</v-icon>
      </v-avatar>
    </v-col>
    <v-col class="py-0 px-2" :cols="size">
      <span
        class="color-blue explorer font-dm ma-0 fakeLink"
        @click="goTo('/jornada')"
        v-if="journey"
      >
        {{ journey.etapa }}
      </span>
      <br />
      <span
        class="color-purple username font-dm fakeLink"
        @click="goTo('/jornada')"
      >
        {{ user.name }}</span
      >
      <br />
      <div class="bar">
        <div class="user-bar">
          <div class="user-bar-experience" :style="getStyle()"></div>
        </div>
        <div class="user-bar-label font-dm">{{ experience }} %</div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["user", "journey"]),
    experience() {
      if (!this.journey) {
        return 0;
      }
      if (!this.journey.ideias || !this.journey.acoes || !this.journey.quiz) {
        return 0;
      }

      let atualIdeias =
        (this.journey.ideias.atual * 100) / this.journey.ideias.meta;
      let atualAcoes =
        (this.journey.acoes.atual * 100) / this.journey.acoes.meta;
      let atualQuiz = (this.journey.quiz.atual * 100) / this.journey.quiz.meta;

      if (atualIdeias > 100) atualIdeias = 100;
      if (atualAcoes > 100) atualAcoes = 100;
      if (atualQuiz > 100) atualQuiz = 100;

      const final = Math.round(
        atualIdeias / 3 + atualAcoes / 3 + atualQuiz / 3
      );

      if (isNaN(final)) {
        return 0;
      } else {
        return final;
      }
    },
  },
  props: {
    size: {
      type: String,
      default: "9",
    },
  },
  methods: {
    getStyle() {
      return "width: " + this.experience + "%";
    },
    goTo(rota) {
      this.$router.push(rota);
    },
  },
};
</script>

<style>
.explorer {
  font-size: 13px;
  margin: 0x !important;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
  text-transform: capitalize;
}
.username {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 21px;
  text-transform: capitalize;
}
.user-bar {
  position: relative;
  background: #f3f3f3;
  height: 10px;
  width: 80%;
  display: inline-block;
}

.user-bar-label {
  width: 20%;
  padding: 0px 4px;
  display: inline-block;
  opacity: 0.5;
  color: #502d7c;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
}

.user-bar-experience {
  left: 0px;
  height: 10px;
  background: rgb(247, 163, 20);
  background: linear-gradient(90deg, #f7a412 0%, #ed6fa7 100%);
  position: absolute;
  border-radius: 100px;
}
</style>
